import React, { useEffect, useState } from "react";
import { Grid, Button, Paper, useMediaQuery, Box, Modal } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import { fcheck_null_undefine_replace_empty } from "../../../Utility/Utilitys";
import { INV10_Request_Variance_GetRow } from "../../../Server/ApiV2";
import { StockTransferRo } from "../../../Redux/roStore";

const GCReqvsTransfer = ({
  open = false,
  fCloseSearchModal = () => {},
  xTitle = "Requset vs Transfer",
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const [rows, setRows] = useState([]);

  const [columns, setcolumn] = useState([
    { field: "B_ItmCd", headerName: "Item Code", width: 150 },
    { field: "ItemName", headerName: "Item Name", width: 250 },
    { field: "ReqQty", headerName: "Requested Qty", width: 100 },
    { field: "IssuedQty", headerName: "Issued Qty", width: 100 },
  ]);

  const handleLoad = async () => {
    const { HeadObject } = StockTransferRo();
    const payload = {
      RefDocTyp: HeadObject.A_RefDocCd,
      RefDocno: HeadObject.A_RefDocType,
      VocTyp: HeadObject.A_VocTyp,
      VocNo: HeadObject.A_VocNo,
    };
    let resp = await INV10_Request_Variance_GetRow(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      let { recordset } = resp?.data;
      const loadedData =
        recordset.length == 0
          ? []
          : recordset.map((item, index) => ({
              ...item,
              id: index + 1,
            }));
      setRows(loadedData);
    } else {
      setRows([]);
    }
  };

  useEffect(() => {
    if (open) {
      handleLoad();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={() => {
        setRows([]);
        fCloseSearchModal();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box sx={{ overflow: "auto" }} className="model-GCSearchBtn">
          <GCTitleSticky
            title={xTitle}
            onClose={() => {
              setRows([]);
              fCloseSearchModal();
            }}
          />

          <Paper style={{ padding: "5px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div
                  style={{
                    height: vMediaQuery ? "80vh" : "72vh",
                    width: "100%",
                  }}
                  id="table-main-grid-4"
                >
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                      cursor: "pointer",
                    }}
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => row.id}
                    hideFooter={rows.length < 100}
                  />
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </div>
    </Modal>
  );
};

export default GCReqvsTransfer;
